import { Card, CardContent, IconButton } from '@mui/material';
import React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { AgendasTypes, IAppointment, IDepartment, DEFAULT_CLINIC_TIMEZONE } from '../../../constants/types';
import { FormMakeAppointment } from '../../../pages/hospital/Outpatients/FormAppointment';
import { cancelAppointmentService, getAgendasConfig } from '../../../services/agenda';
import { stringDatePostgresToDate } from '../../../utils/index.jsx';
import Loader from '../../Loader';
import { IconGenerator } from '../mini_components';

interface AppointmentFieldProps extends LocalizeContextProps{
    uuidPatient: string;
    uuidInvestigation: string;
    value:string;
    label:string;
    department:IDepartment;
    appointmentSelected:(date:number | null) => void
}

const AppointmentField: React.FC<AppointmentFieldProps> = ({ label,  uuidPatient, value, department, activeLanguage, uuidInvestigation, appointmentSelected }) => {
    const [appointment, setAppointment] = React.useState<IAppointment | null>(null);
    const [loading, setLoading] = React.useState<boolean>(false);
    // Appointment days are a clinic-local concept, so render them in the clinic
    // timezone rather than the viewer's browser. The configured tz isn't in scope
    // here (this smartfield renders outside the Outpatients page), so resolve it
    // from the investigation's AgendaConfig; fall back to the default until loaded.
    const [clinicTimezone, setClinicTimezone] = React.useState<string>(DEFAULT_CLINIC_TIMEZONE);

    React.useEffect(() => {
        let mounted = true;
        getAgendasConfig(uuidInvestigation)
            .then(response => {
                if (mounted) setClinicTimezone(response.agendaConfig?.params?.timezone || DEFAULT_CLINIC_TIMEZONE);
            })
            .catch(() => {
                if (mounted) setClinicTimezone(DEFAULT_CLINIC_TIMEZONE);
            });
        return () => { mounted = false; };
    }, [uuidInvestigation]);

    function appointmentMadeCallback(appointment:IAppointment) {
        setAppointment(appointment);
        appointmentSelected(appointment.startDateTime);
    }

    function deleteAppointment(){
        if(appointment){
            setLoading(true);
            cancelAppointmentService(uuidInvestigation, appointment.uuid)
                .then(response => {
                    setLoading(false);
                    appointmentSelected(null);
                })
                .catch(err => {
                    setLoading(false);
                })
        }
    }

    function renderContent(){
        if(loading){
            return <Loader />
        }
        if(value){
            const date = stringDatePostgresToDate(value);
            return <>
                { label }: {date.toLocaleDateString(activeLanguage.code, { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: clinicTimezone })}
                { appointment && 
                    <IconButton
                        onClick={(e) => {
                            deleteAppointment();
                            e.stopPropagation();
                        }}
                        size="large">
                        
                        <IconGenerator type="delete" />
                    </IconButton>   
                }
            </>;
        }
        return (
            <>
                <FormMakeAppointment uuidPatient={uuidPatient} 
                    uuidInvestigation={uuidInvestigation} showAllAgendas={false}
                    hidePatientInfo={true} department={department}
                    typeAgenda={AgendasTypes.CONSULTATION}
                    appointmentMadeCallback={(date) => appointmentMadeCallback(date)} />
            </>
        );
    }

    return (
        <Card variant="outlined">
            <CardContent>
                { renderContent()}
            </CardContent>
        </Card>
    )
    
};

export default withLocalize(AppointmentField);
